import _default from './Comment';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/views/Comment/index.js
// module id = 706
// module chunks = 0